export const renkoMultipliers = [
   { text: '0.0', value: 0.0 },
   { text: '0.5', value: 0.5 },
   { text: '1.0', value: 1.0 },
   { text: '1.5', value: 1.5 },
   { text: '2.0', value: 2.0 },
   { text: '2.5', value: 2.5 },
   { text: '3.0', value: 3.0 },
   { text: '3.5', value: 3.5 }
]